import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'
import { AppDownloadSection } from "../../components/StyledAppDownloadSection.styled"
import { AppContentSection, } from '../../components/StyledAppContentSection.styled'
import { InnerAppDownloadTextSection } from '../../components/StyledAppDownloadSection.styled'

export const StyledAppDownloadSectionTop = styled(AppDownloadSection)({
    paddingTop: "0px",
})

export const AppDownloadButtonsSection = styled('div')({
    paddingTop: calcRem(32),
    paddingBottom: calcRem(64),
    width: '100%',
    height: 'fit-content',
    gap: calcRem(8),
    display: 'flex',
    justifyContent: "left",
})

export const InnerAppDownloadTextSectionTop = styled(
    InnerAppDownloadTextSection,
)({
    // Display a full width & smaller gap on mobile devices
    width: '100%',
    gap: calcRem(8),

    // larger gap on tablet or larger devices
    [breakpoint('sm')]: {
        width: '100%',
        gap: calcRem(20),
    },
})

export const StyledAppDownloadImage = styled('img')({
    marginLeft: 'auto',

    // Hide the top image on the mobile devices
    display: 'none',

    // Show the first phone image on tablet or larger versions
    [breakpoint('sm')]: {
        display: 'flex',
    },
})

export const AppDownloadContentSectionTop = styled(AppContentSection)(({ theme }) => ({
    display: "block",

    width: "100%",

    [breakpoint('sm')]: {
        width: "100%",
        padding: calcRem(0, 64),
        flexDirection: 'row',
    },

    [breakpoint('xl')]: {
        width: theme.siteMetrics.mainContentWidth,
    },
}))
